// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Unified Header Styles
 * Consistent header styling for all management pages
 */

/* Unified Header */
.unified-header {
    background:
        radial-gradient(circle at 20% 80%, rgba(234, 88, 12, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(253, 186, 116, 0.1) 0%, transparent 50%),
        linear-gradient(135deg, #EA580C, #FDBA74);
    padding: 30px;
    color: white;
    position: relative;
    overflow: hidden;
}

.unified-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
    pointer-events: none;
}

.unified-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
}

.unified-title-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

.unified-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
}

.unified-icon .icon {
    font-size: 2rem;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.unified-title-info h2 {
    color: white;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 8px 0;
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.unified-title-info p {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    margin: 0 0 12px 0;
    line-height: 1.5;
}

.unified-count {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.2);
    padding: 8px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
}

.count-number {
    font-size: 1.2rem;
    font-weight: 700;
    color: white;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.count-label {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
}

.unified-actions-section {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.unified-selection-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.unified-selection-count {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(34, 197, 94, 0.2);
    padding: 8px 16px;
    border-radius: 12px;
    border: 1px solid rgba(34, 197, 94, 0.4);
    backdrop-filter: blur(10px);
}

.selected-number {
    font-size: 1.1rem;
    font-weight: 700;
    color: #22c55e;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.selected-label {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .unified-header-content {
        flex-direction: column;
        gap: 20px;
        text-align: center;
    }

    .unified-actions-section {
        justify-content: center;
        flex-direction: column;
        gap: 15px;
    }
}

@media (max-width: 768px) {
    .unified-header {
        padding: 20px;
    }

    .unified-title-section {
        flex-direction: column;
        gap: 16px;
        text-align: center;
    }

    .unified-icon {
        width: 50px;
        height: 50px;
    }

    .unified-title-info h2 {
        font-size: 1.5rem;
    }

    .unified-actions-section {
        justify-content: center;
        flex-direction: column;
        gap: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/common/UnifiedHeader.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mBAAmB;AACnB;IACI;;;iDAG6C;IAC7C,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;yFAEqF;IACrF,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;IACzC,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":["/**\n * Unified Header Styles\n * Consistent header styling for all management pages\n */\n\n/* Unified Header */\n.unified-header {\n    background:\n        radial-gradient(circle at 20% 80%, rgba(234, 88, 12, 0.1) 0%, transparent 50%),\n        radial-gradient(circle at 80% 20%, rgba(253, 186, 116, 0.1) 0%, transparent 50%),\n        linear-gradient(135deg, #EA580C, #FDBA74);\n    padding: 30px;\n    color: white;\n    position: relative;\n    overflow: hidden;\n}\n\n.unified-header::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background:\n        radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.05) 0%, transparent 50%),\n        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);\n    pointer-events: none;\n}\n\n.unified-header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    z-index: 2;\n}\n\n.unified-title-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.unified-icon {\n    width: 60px;\n    height: 60px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    backdrop-filter: blur(10px);\n}\n\n.unified-icon .icon {\n    font-size: 2rem;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.unified-title-info h2 {\n    color: white;\n    font-size: 1.8rem;\n    font-weight: 700;\n    margin: 0 0 8px 0;\n    line-height: 1.2;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.unified-title-info p {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 1rem;\n    margin: 0 0 12px 0;\n    line-height: 1.5;\n}\n\n.unified-count {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(255, 255, 255, 0.2);\n    padding: 8px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    backdrop-filter: blur(10px);\n}\n\n.count-number {\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: white;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.count-label {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 500;\n}\n\n.unified-actions-section {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.unified-selection-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.unified-selection-count {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(34, 197, 94, 0.2);\n    padding: 8px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(34, 197, 94, 0.4);\n    backdrop-filter: blur(10px);\n}\n\n.selected-number {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #22c55e;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.selected-label {\n    font-size: 0.9rem;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: 500;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n    .unified-header-content {\n        flex-direction: column;\n        gap: 20px;\n        text-align: center;\n    }\n\n    .unified-actions-section {\n        justify-content: center;\n        flex-direction: column;\n        gap: 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    .unified-header {\n        padding: 20px;\n    }\n\n    .unified-title-section {\n        flex-direction: column;\n        gap: 16px;\n        text-align: center;\n    }\n\n    .unified-icon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .unified-title-info h2 {\n        font-size: 1.5rem;\n    }\n\n    .unified-actions-section {\n        justify-content: center;\n        flex-direction: column;\n        gap: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
